/* eslint-disable guard-for-in */
/* eslint-disable no-case-declarations */
/* eslint-disable no-restricted-syntax */
import { each } from "lodash";
import { ActionTypes } from "../actions/types";
import {
    NAVIGATION_NEXT_PAGE,
    ENABLE_MAPPED_VARIABLE_FIELD_STATUS,
    RESET_MENTIONS,
    SET_VARIABLE_MENTIONS,
    UPDATE_QUESTION_FIELD_STATUS,
} from "../actions";
import { QuestionnaireModel } from "../../models/QuestionnaireModel";
import { QuestionType } from "../../models/enums/QuestionType";
import { getQuestionWithVariable } from "../../models/utilities/questionnaireUtilities";

import { MentionModel } from "../../models/MentionModel";
import { getSettingString } from "../../models/utilities/settingUtilities";
import { AxisModel } from "../../models/AxisModel";
import { QuestionModel } from "../../models/QuestionModel";
import { VariableModel } from "../../models/VariableModel";
const INITIAL_STATE = {};

export const questionFieldStatusReducer = (
    state = INITIAL_STATE,
    action: ActionTypes,
    questionnaire: QuestionnaireModel,
    oldMentionsByVariableName: { [variableName: string]: MentionModel[] }, // Previous saved mentions for variables
    newMentionsByVariableName: { [variableName: string]: MentionModel[] }, // New changed mentions for variables
) => {
    const reducerStates = { ...state };
    const changeReducerStateForVariableCells: [string, boolean, any][] = [];
    let disableColumnsList = [];

    switch (action.type) {
        case NAVIGATION_NEXT_PAGE:
            each(oldMentionsByVariableName, (mentions, variableName) => {
                if (Object.keys(oldMentionsByVariableName).includes(variableName)) {
                    const question = getQuestionWithVariable(questionnaire, variableName);
                    if (question) {
                        updateStatusForHybridQuestionMapppedVariableCells(
                            action.type,
                            question,
                            reducerStates,
                            variableName,
                            disableColumnsList,
                            changeReducerStateForVariableCells,
                            oldMentionsByVariableName,
                            true,
                            false,
                        );
                    }
                }
                disableColumnsList = []; // For each row reset column might be different
            });

            setDisabledStatesForVariables(
                NAVIGATION_NEXT_PAGE,
                reducerStates,
                changeReducerStateForVariableCells,
            );

            return reducerStates;
        case SET_VARIABLE_MENTIONS:
            updateStateAfterMentionsComparison(
                SET_VARIABLE_MENTIONS,
                reducerStates,
                questionnaire,
                newMentionsByVariableName, //In set variablemention newmentions is reversed with old due to being newer state on current page
                oldMentionsByVariableName,
                true,
                true,
            );
            return reducerStates;
        case RESET_MENTIONS:
            updateStateAfterMentionsComparison(
                RESET_MENTIONS,
                reducerStates,
                questionnaire,
                oldMentionsByVariableName,
                action.mentions, // this action.mentions contains new mentions for reset case
                false,
                false,
            );

            return reducerStates;
        case UPDATE_QUESTION_FIELD_STATUS:
            const { fieldIdentifiers, checkAndSetToState, isDisabled } = action;

            if (!checkAndSetToState) {
                // If is called when intially the status being set for variable cell
                for (const key in fieldIdentifiers) {
                    const fieldKey = fieldIdentifiers[key];
                    if (!reducerStates[fieldKey]) {
                        // Initialize the state for new instanceId
                        reducerStates[fieldKey] = {
                            isDisabled: action.isDisabled,
                        };
                    } else {
                        // Update the state for existing instanceId
                        reducerStates[fieldKey] = {
                            ...reducerStates[fieldKey],
                            isDisabled: action.isDisabled,
                        };
                    }
                }
            } else {
                const mapperVariable: [string, boolean, any][] = fieldIdentifiers.map((item) => [
                    item,
                    isDisabled,
                    [],
                ]);

                updateFieldStatusAndMappedFieldOnSelection(
                    questionnaire,
                    mapperVariable,
                    newMentionsByVariableName,
                );

                setDisabledStatesForVariables(
                    ENABLE_MAPPED_VARIABLE_FIELD_STATUS,
                    reducerStates,
                    mapperVariable,
                );
            }

            return reducerStates;
        case ENABLE_MAPPED_VARIABLE_FIELD_STATUS:
            const { variableName, mentions } = action;
            const question = getQuestionWithVariable(questionnaire, variableName);

            // Trigger when hide logic is associated so check for current row only
            if (question) {
                enableMappedVariableFieldStatus(
                    question,
                    reducerStates,
                    variableName,
                    mentions, // current variable latest state
                    changeReducerStateForVariableCells,
                    disableColumnsList,
                    true,
                    true,
                    action.type,
                );
            }

            enableMappedDisabledFields(
                reducerStates,
                questionnaire,
                ENABLE_MAPPED_VARIABLE_FIELD_STATUS,
                changeReducerStateForVariableCells,
                mentions,
            );

            setDisabledStatesForVariables(
                ENABLE_MAPPED_VARIABLE_FIELD_STATUS,
                reducerStates,
                changeReducerStateForVariableCells,
            );
            return reducerStates;
        default:
            return reducerStates;
    }
};

/*
    updateFieldStatusAndMappedFieldOnSelection: To be used for enabling if linked field is disabled on choice/input value selection for selected variable row only.
*/
function updateFieldStatusAndMappedFieldOnSelection(
    questionnaire: QuestionnaireModel,
    changeReducerStateForVariableCells: [string, boolean, any][],
    mentions: any,
) {
    let question: QuestionModel;
    let row: AxisModel[] = [];
    let disableColumnsList: any = [];
    changeReducerStateForVariableCells.forEach(([identifierId, isDisabled]) => {
        const splitedValues = identifierId.split("&"); // questionId & VariableName
        let variableName = splitedValues[1];

        // Fetch details only for the first item as row is same
        if (!question) {
            question = getQuestionWithVariable(questionnaire, variableName);
            if (question) {
                row = getFilteredRowsForQuestion(question, variableName, false);
                if (row && row.length > 0) {
                    getDisabledColumnsForRowBasedOnChoiceSelected(
                        row[0],
                        disableColumnsList,
                        mentions,
                    );
                }
            }
        }

        if (row && row.length > 0) {
            getStatusForEntireRowVariableOnSelectionChange(
                question,
                row[0],
                disableColumnsList,
                identifierId,
                changeReducerStateForVariableCells,
            );
        }
    });
}

// To be used for enabling if linked field is disabled.
function enableMappedDisabledFields(
    reducerStates: any,
    questionnaire: QuestionnaireModel,
    actionType: string,
    changeReducerStateForVariableCells: [string, boolean, any][],
    mentions: any,
) {
    changeReducerStateForVariableCells.forEach(([identifierId, isDisabled, disableColumnsList]) => {
        if (
            (actionType === ENABLE_MAPPED_VARIABLE_FIELD_STATUS ||
                actionType === SET_VARIABLE_MENTIONS) &&
            isDisabled &&
            reducerStates[identifierId] &&
            !reducerStates[identifierId].isDisabled // Earlier was enabled and now field is supposed to be disabled check for those kind of field only
        ) {
            const splitedValues = identifierId.split("&"); // questionId & VariableName
            let variableName = splitedValues[1];

            // execute for enabling only if state of linked field is dis
            const question = getQuestionWithVariable(questionnaire, variableName);
            if (question) {
                const filteredRows = getFilteredRowsForQuestion(question, variableName, false);
                if (filteredRows && filteredRows.length > 0) {
                    each(filteredRows, (filteredRow) => {
                        enableStatusForDisabledFieldWhichAreReferenced(
                            question,
                            reducerStates,
                            filteredRow,
                            disableColumnsList,
                            identifierId,
                            changeReducerStateForVariableCells,
                            mentions,
                        );
                    });
                }
            }
        }
    });
}

// call when Hidden triggered to Enable field
function enableMappedVariableFieldStatus(
    question: QuestionModel,
    reducerStates: any,
    variableName: string,
    currentVariableMentions: MentionModel[],
    changeReducerStateForVariableCells: [string, boolean, any][],
    disableColumnsList: any,
    getSingleRow: boolean,
    hideGridVariableCall: boolean,
    actionType: string,
) {
    const result: { [variableName: string]: MentionModel[] } = {};
    result[variableName] = currentVariableMentions;

    updateStatusForHybridQuestionMapppedVariableCells(
        actionType,
        question,
        reducerStates,
        variableName,
        disableColumnsList,
        changeReducerStateForVariableCells,
        result,
        getSingleRow,
        hideGridVariableCall,
    );
}

function findChangedMentionsForVariableNames(
    newMentionsByVariableName: { [variableName: string]: MentionModel[] },
    oldMentionsByVariableName: { [variableName: string]: MentionModel[] },
    checkForNewMentions: boolean,
): { [variableName: string]: MentionModel[] } {
    const result: { [variableName: string]: MentionModel[] } = {};

    // Get old mentions which are removed
    Object.keys(oldMentionsByVariableName).forEach((variableName) => {
        const oldVariableMentions = oldMentionsByVariableName[variableName] || [];
        const newVariableMentions = newMentionsByVariableName[variableName] || [];

        let changeStatusForMentions: any;
        /*  Required because newmentions is reversed with old due to being newer state on current page
            If we stay in same page then mentions are increasing generally if we are selecting new options and 
            when going back to old page reverse is happening actually as new selected mentions are reseted if not being 
            saved on server 
        */
        if (checkForNewMentions) {
            changeStatusForMentions = findMentionsToResetForVariableNames(
                newVariableMentions,
                oldVariableMentions,
            );
        } else {
            changeStatusForMentions = findMentionsToResetForVariableNames(
                oldVariableMentions,
                newVariableMentions,
            );
        }

        if (changeStatusForMentions.length > 0) {
            result[variableName] = changeStatusForMentions;
        } else if (
            !checkForNewMentions &&
            !(newVariableMentions && newVariableMentions.length > 0) &&
            oldVariableMentions
        ) {
            // Set when in current page/question any new variable mention been added
            result[variableName] = newVariableMentions;
        }
    });

    // Get mentions which are added newly and to be removed
    Object.keys(newMentionsByVariableName).forEach((variableName) => {
        const oldVariableMentions = oldMentionsByVariableName[variableName] || [];
        const newVariableMentions = newMentionsByVariableName[variableName] || [];

        let changeStatusForMentions: any;
        if (checkForNewMentions) {
            changeStatusForMentions = findMentionsToResetForVariableNames(
                newVariableMentions,
                oldVariableMentions,
            );
        } else {
            changeStatusForMentions = findMentionsToResetForVariableNames(
                oldVariableMentions,
                newVariableMentions,
            );
        }

        if (changeStatusForMentions.length > 0) {
            result[variableName] = changeStatusForMentions;
        } else if (checkForNewMentions && newVariableMentions && !oldVariableMentions) {
            // Set when in current page/question any new variable mention been added
            result[variableName] = newVariableMentions;
        }
    });

    return result;
}

function findMentionsToResetForVariableNames(
    oldVariableMentions: MentionModel[],
    newVariableMentions: MentionModel[],
): MentionModel[] {
    const changeStatusForMentions: MentionModel[] = [];

    newVariableMentions.forEach((newMention) => {
        const found = oldVariableMentions.find((oldMention) =>
            areMentionsEqual(newMention, oldMention),
        );
        if (!found) {
            changeStatusForMentions.push({ ...newMention });
        }
    });

    return changeStatusForMentions;
}

function areMentionsEqual(mention1: MentionModel, mention2: MentionModel): boolean {
    return (
        mention1.index === mention2.index &&
        mention1.matrix === mention2.matrix &&
        mention1.value === mention2.value &&
        mention1.openEnd === mention2.openEnd &&
        mention1.customChoiceIndex === mention2.customChoiceIndex
    );
}

function setDisabledStatesForVariables(
    type: string,
    reducerStates: any,
    variablesCellStatus: [string, boolean, any][],
) {
    variablesCellStatus.forEach(([identifierId, newStatus, disabledColumnIndexes]) => {
        reducerStates[identifierId] = {
            ...reducerStates[identifierId],
            isDisabled: newStatus,
        };
    });
}

function getFilteredRowsForQuestion(
    question: QuestionModel,
    variableName: string,
    getAllRows: boolean,
) {
    if (getAllRows) {
        return question.rows?.filter((x) => x.variables && x.variables.length > 0);
    } else {
        return question.rows?.filter(
            (x) =>
                x.variables &&
                x.variables.length > 0 &&
                x.variables.find((vb) => vb.name === variableName),
        );
    }
}

export function updateStatusForHybridQuestionMapppedVariableCells(
    actionType: string,
    question: QuestionModel,
    reducerState: any,
    variableName: string,
    disableColumnsList: any,
    changeReducerStateForVariableCells: [string, boolean, any][],
    mentions: { [variableName: string]: MentionModel[] },
    getSingleRow: boolean,
    hideGridVariableCall: boolean,
) {
    if (question.type === QuestionType.HybridGrid) {
        const mappedFieldIdentifier = `${question.id}&${variableName}`;

        const filteredRows = getFilteredRowsForQuestion(question, variableName, !getSingleRow);
        let storedRow: AxisModel;
        if (filteredRows && filteredRows.length > 0) {
            each(filteredRows, (loopRow) => {
                //Fetch disabled column only when row is changes as disable columns remains same
                if (loopRow != storedRow) {
                    storedRow = loopRow;

                    // Get columns to be disabled for entire row if there is any mention selected for it.
                    getDisabledColumnsForRowBasedOnChoiceSelected(
                        loopRow,
                        disableColumnsList,
                        mentions,
                    );
                }

                updateFieldStatusForAllVariablesInAxis(
                    actionType,
                    question,
                    reducerState,
                    loopRow,
                    disableColumnsList,
                    mappedFieldIdentifier,
                    changeReducerStateForVariableCells,
                    hideGridVariableCall,
                );

                disableColumnsList = []; // For each row reset column might be different
            });
        }
    }
}

/*  
    oldMentionsByVariableName & newMentionsByVariableName info
    Required because newmentions is reversed with old due to being newer state on current page
    If we stay in same page then mentions are increasing generally if we are selecting new options and 
    when going back to old page reverse is happening actually as new selected mentions are reseted if not 
    being saved on server 
*/
function updateStateAfterMentionsComparison(
    type: string,
    reducerStates: any,
    questionnaire: QuestionnaireModel,
    oldMentionsByVariableName: { [variableName: string]: MentionModel[] },
    newMentionsByVariableName: { [variableName: string]: MentionModel[] },
    getSingleRow: boolean,
    checkForNewMentions: boolean,
) {
    const changeReducerStateForVariableCells: [string, boolean, any][] = [];
    let changeStateForMentions: { [variableName: string]: MentionModel[] };
    let disableColumnsList = [];

    changeStateForMentions = findChangedMentionsForVariableNames(
        newMentionsByVariableName,
        oldMentionsByVariableName,
        checkForNewMentions,
    );

    each(changeStateForMentions, (mentions, variableName) => {
        if (Object.keys(changeStateForMentions).includes(variableName)) {
            const question = getQuestionWithVariable(questionnaire, variableName);
            if (question) {
                updateStatusForHybridQuestionMapppedVariableCells(
                    type,
                    question,
                    reducerStates,
                    variableName,
                    disableColumnsList,
                    changeReducerStateForVariableCells,
                    checkForNewMentions ? oldMentionsByVariableName : newMentionsByVariableName,
                    getSingleRow,
                    false,
                );
            }
        }
        disableColumnsList = []; // For each row reset column might be different
    });

    enableMappedDisabledFields(
        reducerStates,
        questionnaire,
        type,
        changeReducerStateForVariableCells,
        checkForNewMentions ? oldMentionsByVariableName : newMentionsByVariableName,
    );

    setDisabledStatesForVariables(type, reducerStates, changeReducerStateForVariableCells);
}

export function getDisabledColumnsForRowBasedOnChoiceSelected(
    row: AxisModel,
    disableColumnsList: any,
    mentions: { [variableName: string]: MentionModel[] },
    variableName?: string,
) {
    let variables: VariableModel[];
    if (variableName) {
        variables = row.variables.filter((variable) => variable.name === variableName);
    } else {
        variables = row.variables;
    }

    variables.forEach((loopVariable) => {
        if (loopVariable.choiceList?.length > 0) {
            const mention = mentions[loopVariable.name];

            if (mention && mention.length > 0) {
                loopVariable.choiceList.forEach((choice) => {
                    if (mention && mention.some((x) => x.value === choice.value)) {
                        disableColumnsList.push(getSettingString(choice, "DisableColumns"));
                    }
                });
            }
        }
    });
}

export function enableStatusForDisabledFieldWhichAreReferenced(
    question: QuestionModel,
    reducerState: any,
    row: AxisModel,
    disableColumnsList: any,
    mappedFieldIdentifier: string,
    changeReducerStateForVariableCells: [string, boolean, any][],
    mentions: any,
) {
    // This disableList is for entire row if for row exist then only check for each variable level inside
    if (disableColumnsList && disableColumnsList.length > 0) {
        row.variables.forEach((loopVariable, index) => {
            let disableListForCurrentVariable: any = [];
            getDisabledColumnsForRowBasedOnChoiceSelected(
                row,
                disableListForCurrentVariable,
                mentions,
                loopVariable.name,
            );
            const currentLoopVariableId = `${question.id}&${loopVariable.name}`;

            const fieldIsDisabledInState =
                reducerState[currentLoopVariableId] &&
                reducerState[currentLoopVariableId].isDisabled;

            const isDisabledFieldWhichIsToBeEnabled = disableListForCurrentVariable
                .join(",")
                .replace(/\s/g, "")
                .split(",")
                .some((c) => c.toString() === index.toString());

            // Field is disabled and to be enabled if is a different field
            if (
                isDisabledFieldWhichIsToBeEnabled &&
                fieldIsDisabledInState &&
                mappedFieldIdentifier !== currentLoopVariableId
            ) {
                checkAndPushIntoListForStateUpdation(
                    currentLoopVariableId,
                    changeReducerStateForVariableCells,
                    false,
                    [], // set disable list blank as field state is already disabled so no choice can exist
                );
            }
        });
    }
}

export function getStatusForEntireRowVariableOnSelectionChange(
    question: QuestionModel,
    row: AxisModel,
    disableColumnsList: any,
    mappedFieldIdentifier: string,
    changeReducerStateForVariableCells: [string, boolean, any][],
) {
    row.variables.forEach((loopVariable, index) => {
        const currentLoopIdentifier = `${question.id}&${loopVariable.name}`;
        let fieldNewStatus = false;

        if (disableColumnsList && disableColumnsList.length > 0) {
            fieldNewStatus = disableColumnsList
                .join(",")
                .replace(/\s/g, "")
                .split(",")
                .some((c) => c.toString() === index.toString());
        }

        //only update fields if status is changed
        if (mappedFieldIdentifier !== currentLoopIdentifier) {
            checkAndPushIntoListForStateUpdation(
                currentLoopIdentifier,
                changeReducerStateForVariableCells,
                fieldNewStatus,
                [],
            );
        }
    });
}

export function updateFieldStatusForAllVariablesInAxis(
    actionType: string,
    question: QuestionModel,
    reducerState: any,
    row: AxisModel,
    disableColumnsList: any,
    mappedFieldIdentifier: string,
    changeReducerStateForVariableCells: [string, boolean, any][],
    hideGridVariableCall: boolean,
) {
    row.variables.forEach((loopVariable, index) => {
        const refrencedFieldIdentifier = `${question.id}&${loopVariable.name}`;
        let fieldNewStatus = false;

        if (disableColumnsList && disableColumnsList.length > 0) {
            const isDisabled = disableColumnsList
                .join(",")
                .replace(/\s/g, "")
                .split(",")
                .some((c) => c.toString() === index.toString());

            if (isDisabled && mappedFieldIdentifier !== refrencedFieldIdentifier) {
                fieldNewStatus = true;
            }
        }

        const fielStatusIsChanged =
            reducerState[refrencedFieldIdentifier] &&
            reducerState[refrencedFieldIdentifier].isDisabled !== fieldNewStatus;

        /*  only update fields if status is changed remaining on current page
            or 
            when moving to next page.
        */
        if (fielStatusIsChanged || actionType === NAVIGATION_NEXT_PAGE) {
            checkAndPushIntoListForStateUpdation(
                refrencedFieldIdentifier,
                changeReducerStateForVariableCells,
                fieldNewStatus,
                disableColumnsList,
            );
        } else if (!fielStatusIsChanged && hideGridVariableCall) {
            // Enable disabled cells when variable is hidden
            checkAndPushIntoListForStateUpdation(
                refrencedFieldIdentifier,
                changeReducerStateForVariableCells,
                false,
                disableColumnsList,
            );
        }
    });
}

function checkAndPushIntoListForStateUpdation(
    fieldIdentifier: string,
    changeReducerStateForVariableCells: [string, boolean, any][],
    status: boolean,
    currentDisableList: any,
) {
    if (changeReducerStateForVariableCells && changeReducerStateForVariableCells.length > 0) {
        const indexToUpdate = changeReducerStateForVariableCells.findIndex(
            ([identifier]) => identifier === fieldIdentifier,
        );

        if (indexToUpdate !== -1) {
            changeReducerStateForVariableCells[indexToUpdate][1] = status;
        } else {
            changeReducerStateForVariableCells.push([fieldIdentifier, status, currentDisableList]);
        }
    } else {
        changeReducerStateForVariableCells.push([fieldIdentifier, status, currentDisableList]);
    }
}
